import { chakra } from '@chakra-ui/react';
import { ComponentProps } from 'react';

const ExternalLink = (
  { children, ...rest }: ComponentProps<typeof chakra.a>,
) => (
  <chakra.a target="_blank" textDecoration="underline" color="blue.600" {...rest}>{children}</chakra.a>
);

export default ExternalLink;
